/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_TranscriptInputs */



/**
* | output |
* | --- |
* | "Text Transcript" |
*
* @param {Text_TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_transcript = /** @type {((inputs?: Text_TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Texttranskript")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текстовая расшифровка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción del texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストトランスクリプト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पाठ प्रतिलेख")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição do texto")
	return /** @type {LocalizedString} */ ("Text Transcript")
});